import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable, OnDestroy } from '@angular/core';
import { ScreenSize } from 'app/configs/screen';
import { DisplayMode } from 'app/modules/dashboard/models/screen.model';
import { BehaviorSubject, distinctUntilChanged, Observable, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScreenService implements OnDestroy {
  private screenMode = new BehaviorSubject<DisplayMode>(DisplayMode.big);
  public readonly screenMode$: Observable<DisplayMode> = this.screenMode.asObservable().pipe(distinctUntilChanged());
  mode = DisplayMode.big;
  subscriptions: Subscription;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
  ) {
    this.subscriptions = this.breakpointObserver
    .observe([`(max-width: ${ScreenSize.mobile})`])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.mode = DisplayMode.mobile;
      } else {
        this.mode = DisplayMode.big;
      }
      this.screenMode.next(this.mode);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
